import React, { useEffect, useState } from "react";
import { StateroomsMap } from "../../utils/helperFunctions/Stateroom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addItem } from "../../redux/cart-items";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  formatUSAmount,
  islessthan3days,
} from "../../utils/helperFunctions/helperFunctions";

const StateRoomCard = ({
  stateroom,
  selectedCabin,
  guest_count_per_cabin,
  selectedRoom,
}) => {
  const dispatch = useDispatch();
  let cartData = useSelector((state) => state.cart.cartItems);
  let bookingDetails = useSelector((state) => state.bookingValidation.data);
  const [itemAdded, setItemAdded] = useState(false);
  useEffect(() => {
    if (cartData.length > 0) {
      cartData.forEach((item) => {
        if (
          item.stateroom?.category_name === stateroom?.category_name &&
          item.prev_cabin?.room_id === +selectedCabin.split("-")[0]
        ) {
          setItemAdded(true);
        } else setItemAdded(false);
      });
    }
  }, [cartData, stateroom, selectedCabin]);

  const handleAddToCart = () => {
    if (islessthan3days(bookingDetails)) return;
    if (bookingDetails.payment_details.due_amount > 0) {
      toast.error("Please complete your cruise payment to add enhancements");
      return;
    }
    dispatch(
      addItem({
        stateroom: stateroom,
        prev_cabin: {
          room_id: +selectedCabin.split("-")[0],
          category_name: selectedCabin.split("-")[1],
          room_no: selectedRoom,
        },
      })
    );
  };
  const images =
    StateroomsMap[stateroom.category_name]?.img_name ||
    StateroomsMap.default.img_name;

  return (
    stateroom?.diff_price > 0 && (
      <>
        <div className="relative bg-mv-lightblue rounded-lg shadow-lg max-w-md mx-auto">
          <div className="flex justify-between flex-col h-full">
            <div>
              <Carousel
                showArrows={true}
                autoPlay={true}
                interval={2000}
                dynamicHeight={true}
                infiniteLoop={true}
                showThumbs={false}
              >
                {images.map((img, index) => (
                  <div key={index}>
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/UpgradeStateroom/Staterooms/${img}.jpg`}
                      alt={`Stateroom ${index}`}
                      className="w-full h-64 object-cover rounded-t-lg"
                    />
                  </div>
                ))}
              </Carousel>
              <div className="p-6">
                <h2 className="text-2xl font-bold mb-4">
                  {stateroom.category_name}
                </h2>
                <p className="text-[#000] ">
                  {StateroomsMap[stateroom.category_name]?.short_desc ||
                    StateroomsMap.default.short_desc}
                </p>
              </div>
            </div>
            <div className="p-6">
              <div className="flex gap-5 items-center mb-6">
                <span className="line-through text-[#626262] text-lg">
                  $
                  {formatUSAmount(
                    stateroom?.original_amount / guest_count_per_cabin
                  )}
                </span>
                {guest_count_per_cabin && (
                  <span className="text-2xl text-[#6699C2] font-bold">
                    $
                    {formatUSAmount(
                      stateroom?.diff_price / guest_count_per_cabin
                    )}{" "}
                  </span>
                )}
                <span className="text-black italic">per person</span>
              </div>
              <div className="flex space-x-4">
                <button
                  onClick={() => (itemAdded ? null : handleAddToCart())}
                  className="bg-mv-darkblue hover:bg-blue-800 text-white font-bold py-2 px-4 rounded"
                >
                  {itemAdded ? (
                    <div className="flex gap-2 justify-center items-center">
                      <svg
                        width="12"
                        height="9"
                        viewBox="0 0 12 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.8493 8.28542L0.165966 4.60208C-0.055322 4.3808 -0.055322 4.022 0.165966 3.80069L0.967335 2.9993C1.18862 2.77799 1.54744 2.77799 1.76873 2.9993L4.25 5.48055L9.56461 0.165966C9.78589 -0.055322 10.1447 -0.055322 10.366 0.165966L11.1674 0.967357C11.3887 1.18865 11.3887 1.54744 11.1674 1.76875L4.65069 8.28544C4.42938 8.50673 4.07059 8.50673 3.8493 8.28542Z"
                          fill="white"
                        />
                      </svg>
                      ADDED TO CART
                    </div>
                  ) : (
                    "ADD TO CART"
                  )}
                </button>
                <button
                  onClick={() =>
                    window.open(
                      StateroomsMap[stateroom.category_name]?.long_desc ||
                        StateroomsMap.default.long_desc,
                      "_blank"
                    )
                  }
                  className="bg-white hover:bg-gray-200 text-blue-900 font-bold py-2 px-4 rounded border border-mv-darkblue"
                >
                  LEARN MORE
                </button>
              </div>
            </div>
            {/* {showAddToCartModal && (
            <div className="fixed bg-mv-backdrop z-10 bg-opacity-80 left-0 right-0 top-0 bottom-0 m-auto">
              <AddToCartModal
                stateroom={stateroom}
                setShowAddToCartModal={setShowAddToCartModal}
              />
            </div>
          )} */}
          </div>
        </div>
      </>
    )
  );
};

export default StateRoomCard;
